import { Component, inject, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WebcamService, Camera } from '../services/webcam-overlay.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'webcam-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './webcam-overlay.component.html',
  styleUrls: ['./webcam-overlay.component.scss']
})
export class WebCamComponent implements OnInit  {
  private webcamService = inject(WebcamService);
  cameras: Camera[] = [];
  private subscription: Subscription = new Subscription();
  private userInteracted: boolean = false;

  ngOnInit(): void {
    this.subscription.add(
      this.webcamService.cameras$.subscribe(cameras => {
        this.cameras = cameras;
      })
    );

    this.webcamService.loadCameras().subscribe();
    this.webcamService.startPolling(5000);
  }

   @HostListener('document:touchstart')
  onDocumentTouch(): void {
    if (!this.userInteracted) {
      this.userInteracted = true;
      this.webcamService.unmuteAll();
      this.reloadAllIframes();
    }
  }

  private reloadAllIframes(): void {
    // Временное обнуление URL для перезагрузки всех iframe
    const originalUrls = this.cameras.map(cam => cam.vdo_ninja_link);
    
    this.cameras.forEach((cam, index) => {
      cam.vdo_ninja_link = null;
    });

    setTimeout(() => {
      this.cameras.forEach((cam, index) => {
        cam.vdo_ninja_link = originalUrls[index];
      });
    }, 100);
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getSafeUrl(url: string | null): SafeResourceUrl {
    return this.webcamService.getCachedSafeUrl(url);
  }

  trackByCameraId(index: number, camera: Camera): number {
    return camera.id;
  }
}